module.exports = __webpack_public_path__ + "media/images/logo_name-4a3a1a61fdeb6d07c84fade276dddde1.svg";